export * from './equipment-create';
export * from './equipment-edit';
export * from './equipment-detail';
export * from './equipment-summary';
export * from './equipment-routing.module';
export * from './equipment.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/index.ts